'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _components = require('../../../../components');






var _capitalizeFirstLetter = require('../../../../helpers/capitalizeFirstLetter');var _capitalizeFirstLetter2 = _interopRequireDefault(_capitalizeFirstLetter);
var _formatAddress = require('../../../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);
var _formatCurrency = require('../../../../utils/formatCurrency');var _formatCurrency2 = _interopRequireDefault(_formatCurrency);
var _beautifyNumber = require('../../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _checkIsForeignAddress = require('../../../../helpers/checkIsForeignAddress');var _checkIsForeignAddress2 = _interopRequireDefault(_checkIsForeignAddress);
var _getIconStatus = require('../../../../utils/getIconStatus');
var _makeSharingUrl = require('../../../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _constants = require('../../../../constants');
var _appendLocale = require('../../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _helpers = require('../../../../containers/PropertiesTable/helpers');var _helpers2 = _interopRequireDefault(_helpers);

var _config = require('./config');var _config2 = _interopRequireDefault(_config);
var _formatSEOData = require('../../../../utils/formatSEOData');
var _images_placeholder = require('../../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);

var _OMAgentManageCell = require('./OMAgentManageCell.scss');var styles = _interopRequireWildcard(_OMAgentManageCell);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var OMAgentManageCell = function (_Component) {_inherits(OMAgentManageCell, _Component);function OMAgentManageCell() {var _temp, _this, _ret;_classCallCheck(this, OMAgentManageCell);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { isTooltipShown: false,
      isModalControlsOpen: false,
      isModalShareOpen: false,
      tooltipId: null }, _this.


    openDetails = function () {var
      id = _this.props.property.id;
      var route = (0, _appendLocale2.default)(_this.props.locale, '/home_details/' + id);
      _reactRouter.browserHistory.push(route);
    }, _this.

    checkIfJumpToTopDisabled = function () {var _this$props$property =




      _this.props.property,moveToTop = _this$props$property.move_to_top,isPromoted = _this$props$property.is_promoted,isTopPromoted = _this$props$property.is_top_promoted;

      if (isPromoted || isTopPromoted) {
        return true;
      }

      if (moveToTop) {
        return false;
      }

      return true;
    }, _this.

    toggleHighlight = function () {var _this$props$property2 =

      _this.props.property,id = _this$props$property2.id,isPromoted = _this$props$property2.is_promoted,isActive = _this$props$property2.is_active,isSuspended = _this$props$property2.is_suspended,isRocketPromoted = _this$props$property2.is_rocket_promoted;
      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updatePropertyHighlighting({
          ids: [id],
          promote: !isPromoted });

      }
    }, _this.

    toggleTopPromotion = function () {var _this$props$property3 =

      _this.props.property,id = _this$props$property3.id,is_top_promoted = _this$props$property3.is_top_promoted,is_active = _this$props$property3.is_active,is_suspended = _this$props$property3.is_suspended,thumbnail = _this$props$property3.thumbnail,isRocketPromoted = _this$props$property3.is_rocket_promoted;
      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (thumbnail && is_active && !is_suspended && !_this.props.disabledPromotionAction) {
        _this.props.updateTopPromotionActivity({
          ids: [id],
          promote: !is_top_promoted });

      } else {
        _this.props.openMessageModal({ message:
          _react2.default.createElement('div', null, _this.props.translate('managePage', 'requiredPromotionTopDescription')) });

      }
    }, _this.

    toggleAutoJumpActivity = function () {var _this$props$property4 =

      _this.props.property,id = _this$props$property4.id,isActive = _this$props$property4.is_active,isSuspended = _this$props$property4.is_suspended,autoJumpEnabled = _this$props$property4.is_autojump_enabled,isRocketPromoted = _this$props$property4.is_rocket_promoted;
      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isActive && !isSuspended && !_this.props.disabledPromotionAction) {
        _this.props.updateAutoJumpToTopActivity({
          ids: [id],
          enable: !autoJumpEnabled });

      }
    }, _this.

    toggleMoveToTop = function () {var _this$props$property5 =


      _this.props.property,id = _this$props$property5.id,isActive = _this$props$property5.is_active,isSuspended = _this$props$property5.is_suspended,autoJumpEnabled = _this$props$property5.is_autojump_enabled,moveToTop = _this$props$property5.move_to_top,isRocketPromoted = _this$props$property5.is_rocket_promoted;

      var isMovePropertyToTop = isActive && !isSuspended &&
      !_this.props.disabledPromotionAction && !_this.checkIfJumpToTopDisabled();

      if (isRocketPromoted) {
        _this.props.toggleRocketPromoted(_this.props.property, true);
      } else if (isMovePropertyToTop) {
        _this.props.movePropertyToTop(id);
      }
    }, _this.
    toggleActivity = function () {var _this$props$property6 =
      _this.props.property,id = _this$props$property6.id,is_suspended = _this$props$property6.is_suspended,is_active = _this$props$property6.is_active;

      !is_suspended && _this.props.updatePropertyActivity({
        ids: [id],
        active: !is_active });

    }, _this.

    handleEdit = function () {var _this$props$property7 =
      _this.props.property,id = _this$props$property7.id,country_name = _this$props$property7.address.en.country_name;

      _this.props.editProperty(id);
      setTimeout(function () {
        if (country_name.indexOf('Israel') !== -1) {
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/property/edit?id=' + id));
        } else {
          _reactRouter.browserHistory.push((0, _appendLocale2.default)(_this.props.locale, '/foreign_property/edit?id=' + id));
        }
      });
    }, _this.

    clickHandlers = {
      handleEdit: _this.handleEdit,
      openDetailsPopup: _this.openDetails,
      toggleActivity: _this.toggleActivity }, _this.


    formatShareData = function () {var _this$props =
      _this.props,_this$props$property8 = _this$props.property,thumbnail = _this$props$property8.thumbnail,id = _this$props$property8.id,locale = _this$props.locale,translate = _this$props.translate;
      var sharingUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);
      var propertyType = _this.props.translate('propertyTypes', _this.props.property.property_type)();

      var sharingTitle = (0, _formatSEOData.formatPropertyTitle)(
      _this.props.property,
      propertyType,
      translate('propertyDetails'),
      locale);

      return {
        sharingUrl: sharingUrl,
        sharingTitle: sharingTitle,
        thumbnail: thumbnail };

    }, _this.
    toggleRocketPromoted = function () {var
      property = _this.props.property;
      _this.props.toggleRocketPromoted(property);
    }, _this.
    openControlsModal = function () {return _this.setState({ isModalControlsOpen: true });}, _this.
    closeControlsModal = function () {return _this.setState({ isModalControlsOpen: false });}, _this.

    renderControlButton = function (_ref, hideTitle) {var _ref$props = _ref.props,className = _ref$props.className,restProps = _objectWithoutProperties(_ref$props, ['className']),icon = _ref.icon,title = _ref.title;return (
        _react2.default.createElement('button', _extends({
            className: (0, _classnames2.default)(styles.controlButton, className) },
          restProps),

          _react2.default.createElement('i', { className: 'icon icon-' + icon },
            _react2.default.createElement('i', { className: 'path1' }),
            _react2.default.createElement('i', { className: 'path2' })),

          !hideTitle && _react2.default.createElement('div', null, title)));}, _this.



    renderControlsModal = function () {
      var buttonsConfig = (0, _config2.default)(_this.props, _this.clickHandlers);var _this$props2 =






      _this.props,_this$props2$property = _this$props2.property,isActive = _this$props2$property.is_active,address = _this$props2$property.address,isPublishPermissionsForeign = _this$props2.isPublishPermissionsForeign;
      var isForeignProperty = (0, _checkIsForeignAddress2.default)(address);

      return (
        _react2.default.createElement(_components.Modal, {
            isOpen: _this.state.isModalControlsOpen,
            onRequestClose: _this.closeControlsModal,
            className: 'mobileContacts',
            isRtl: _this.props.isRtl },

          _react2.default.createElement('div', { className: styles.mobileMoreControls, onClick: _this.closeControlsModal },
            _react2.default.createElement('div', { className: styles.controlRow },
              _this.renderControlButton(buttonsConfig.preview)),

            !isPublishPermissionsForeign && !isActive && isForeignProperty ? '' :
            _react2.default.createElement('div', { className: styles.controlRow },
              _this.renderControlButton(buttonsConfig.activity)))));





    }, _this.

    renderVRIcon = function () {return _this.props.property.vr_link &&
      _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelVR, 'icon', 'icon-vr-view') },
        _react2.default.createElement('span', { className: 'path1' }),
        _react2.default.createElement('span', { className: 'path2' }),
        _react2.default.createElement('span', { className: 'path3' }),
        _react2.default.createElement('span', { className: 'path4' }),
        _react2.default.createElement('span', { className: 'path5' }));}, _this.



    renderEyeIcon = function () {return (
        _react2.default.createElement('span', { className: 'icon icon-eye' },
          _react2.default.createElement('span', { className: 'path1' }),
          _react2.default.createElement('span', { className: 'path2' })));}, _this.



    renderEditButton = function () {
      var buttonsConfig = (0, _config2.default)(_this.props, _this.clickHandlers);
      return _this.renderControlButton(buttonsConfig.edit, true);
    }, _this.

    renderAddress = function (address) {
      var house = !!address.house_number ? ' ' + address.house_number : '';
      return (
        _react2.default.createElement('span', null,
          address.street_name, house, ',',
          _react2.default.createElement('br', null),
          address.city_name));


    }, _temp), _possibleConstructorReturn(_this, _ret);}OMAgentManageCell.prototype.

  render = function render() {var _cx,_this2 = this,_cx2;var _props$property =



    this.props.property,id = _props$property.id,addressObject = _props$property.address,propertyType = _props$property.property_type,_props$property$addit = _props$property.additional_info,rooms = _props$property$addit.rooms,square = _props$property$addit.area.base,floor = _props$property$addit.floor.on_the,price = _props$property.price,currency = _props$property.currency,createdAt = _props$property.created_at,isActive = _props$property.is_active,isPromoted = _props$property.is_promoted,autoJumpEnabled = _props$property.is_autojump_enabled,is_top_promoted = _props$property.is_top_promoted,isSuspended = _props$property.is_suspended,moveToTop = _props$property.move_to_top,thumbnail = _props$property.thumbnail,images = _props$property.images;

    var isRocketPromoted = (0, _helpers2.default)(this.props.property);var _props =

    this.props,translate = _props.translate,_props$locale = _props.locale,locale = _props$locale === undefined ? 'en' : _props$locale,propertiesAnalytics = _props.propertiesAnalytics,jumpPromotion = _props.jumpPromotion,promotion = _props.promotion,top_promotion = _props.top_promotion;
    var propertyAnalyticsData = propertiesAnalytics &&
    propertiesAnalytics.data && propertiesAnalytics.data.find(function (item) {return item.id === id;});var _ref2 =
    propertyAnalyticsData || {},events = _ref2.events;
    var propertyViewEvent = events && events.find(function (item) {return item.action === _constants.analyticsEventAction.VIEW;});var _ref3 =
    propertyViewEvent || {},propertyViews = _ref3.count;
    var propertyAnalyticsFavouritesData = propertiesAnalytics.favoritesData &&
    propertiesAnalytics.favoritesData.find(function (item) {return item.id === id;});var _ref4 =
    propertyAnalyticsFavouritesData || {},favoritesEvents = _ref4.events;
    var propertyFavoritesEvent = favoritesEvents &&
    favoritesEvents.find(function (item) {return item.action === _constants.analyticsEventAction.FAVOURITES;});var _ref5 =
    propertyFavoritesEvent || {},propertyFavorites = _ref5.count;

    var propertyAnalyticsNumberData = propertiesAnalytics.ShowNumberData &&
    propertiesAnalytics.ShowNumberData.find(function (item) {return item.id === id;});var _ref6 =
    propertyAnalyticsNumberData || {},numberEvents = _ref6.events;
    var propertyNumberEvent = numberEvents &&
    numberEvents.find(function (item) {return item.action === _constants.analyticsEventAction.SHOW_NUMBER;});var _ref7 =
    propertyNumberEvent || {},propertyNumber = _ref7.count;

    // eslint-disable-next-line max-len
    var address = addressObject[locale] ? this.renderAddress(addressObject[locale]) : this.renderAddress(addressObject.en);
    var activity = isActive ? 'active' : 'inactive';
    var status = isSuspended ?
    _react2.default.createElement('div', { className: styles.suspended },
      translate('managePage', 'suspended'),
      _react2.default.createElement(_components.BottomTooltip, {
        className: 'manageTableTooltip',
        msg:
        _react2.default.createElement('span', null,
          translate('managePage', 'suspendedTooltip'),
          _react2.default.createElement('a', {
              href: 'mailto:' + _constants.supportEmail,
              className: 'link',
              onClick: function onClick(evt) {return evt.stopPropagation();} }, ' ', _constants.supportEmail)) })) :






    _react2.default.createElement('i', { className: 'icon icon-' + activity }, _react2.default.createElement('i', { className: 'path1' }), _react2.default.createElement('i', { className: 'path2' }));
    var propType = translate('propertyTypes', propertyType);
    var publishDate = (0, _moment2.default)(createdAt).format('DD/MM/YYYY');
    var houseNumberIsHidden = addressObject && addressObject.hide_house_number;
    var autoJumpStatus = (0, _getIconStatus.getIconStatus)(autoJumpEnabled, jumpPromotion);
    var promotionStatus = (0, _getIconStatus.getIconStatus)(isPromoted, promotion);
    var topPromotionStatus = (0, _getIconStatus.getIconStatus)(is_top_promoted, top_promotion);
    var isForeign = (0, _checkIsForeignAddress2.default)(addressObject);
    var phoneClicksCount = propertyNumber || (0, _get2.default)(this.props, 'property.phone_clicks_count', 0);
    var favouritesCount = propertyFavorites || (0, _get2.default)(this.props, 'property.favourites_count', 0);

    return (
      _react2.default.createElement('div', {
          key: id,
          className: (0, _classnames2.default)(
          styles.cellWrapper, (_cx = {}, _cx[

          styles.inactive] = !isActive || isSuspended, _cx[
          styles.selected] = this.props.isSelected, _cx)) },



        _react2.default.createElement('div', { className: styles.cellRow },
          _react2.default.createElement('div', { className: styles.checkBlock },
            _react2.default.createElement('span', { className: styles.centered }, this.props.numberInOrder),
            _react2.default.createElement(_components.OMCheckbox, {
              id: id,
              label: '',
              className: 'propertyMobileContent',
              customCheckBox: 'customCheckBox',
              withoutLabel: true,
              field: {
                value: false,
                checked: this.props.isSelected,
                onChange: function onChange() {return _this2.props.handleCheck({
                    id: id,
                    isActive: isActive,
                    isForeignProperty: (0, _checkIsForeignAddress2.default)(addressObject) });} } })),




          _react2.default.createElement('div', { className: styles.image },
            _react2.default.createElement('div', { className: styles.statusCell }, status),
            _react2.default.createElement('div', { className: styles.price }, '\u202A' + (0, _formatCurrency2.default)(currency) + ' ' + (0, _beautifyNumber2.default)(price)),
            _react2.default.createElement('div', { className: styles.bgImg, style: { backgroundImage: 'url(' + (thumbnail || _images_placeholder2.default) + ')' } }),
            this.renderVRIcon()),

          _react2.default.createElement('div', { className: styles.infoBlock },
            _react2.default.createElement('div', { className: styles.addressBlock },
              _react2.default.createElement('div', { className: styles.title }, propType, '\xA0', translate('title', this.props.property.search_option)),
              _react2.default.createElement('div', { className: styles.address },
                _react2.default.createElement('div', { onClick: this.openDetails },
                  address),

                _react2.default.createElement('div', { className: styles.addressCell },
                  _react2.default.createElement('div', { className: styles.exclamationTooltip },
                    houseNumberIsHidden &&
                    _react2.default.createElement(_components.BottomTooltip, {
                      icon: _react2.default.createElement('span', { className: styles.exclamationIcon }, _react2.default.createElement('i', { className: 'icon icon-exclamation' })),
                      warnTooltip: true,
                      className: 'exclamationIconTooltip',
                      msg: _react2.default.createElement('span', null, translate('publishProperty', 'houseNumberIsHidden')) })))),




              _react2.default.createElement('div', { className: styles.basicInfo },
                _react2.default.createElement('span', null, rooms, '\xA0', _react2.default.createElement('i', { className: 'icon icon-door' })),
                _react2.default.createElement('span', null, floor, '\xA0', _react2.default.createElement('i', { className: 'icon icon-floor' })))),


            this.renderEditButton())),


        _react2.default.createElement('div', { className: styles.additionalInfo },
          _react2.default.createElement('div', null,
            this.renderEyeIcon(), '\xA0\xA0',
            _react2.default.createElement('span', { className: styles.chartLink },
              propertyViews || '-'),

            _react2.default.createElement('div', { className: styles.publishDate }, '(', publishDate, ')')),

          !isForeign &&
          _react2.default.createElement('div', { className: styles.phoneClicksCount },
            _react2.default.createElement('i', { className: 'icon icon-phone' }), '\xA0\xA0',
            _react2.default.createElement('span', null, phoneClicksCount)),


          _react2.default.createElement('div', { className: styles.favouritesCount },
            _react2.default.createElement('i', { className: 'icon icon-favorite' }), '\xA0\xA0',
            _react2.default.createElement('span', null, favouritesCount)),

          _react2.default.createElement('div', { className: styles.countImg }, images && images.length, '\xA0', translate('managePage', 'images'))),

        _react2.default.createElement('div', { className: styles.actionButtons },
          _react2.default.createElement('span', { className: styles.actionButtonsTitle }, this.props.translate('managePage', 'activePromotions'), ':'),
          isForeign && _react2.default.createElement('span', null, ' - '),
          !isForeign &&
          _react2.default.createElement('i', {
              onClick: this.toggleTopPromotion,
              'data-title': this.props.translate('topPromotion' + (0, _capitalizeFirstLetter2.default)(topPromotionStatus) + 'Title'),
              className: (0, _classnames2.default)(
              'icon', 'icon-top-promotion' +
              (0, _getIconStatus.addEnding)(topPromotionStatus),
              topPromotionStatus === 'disabled' && styles.iconTitle) },


            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),


          !isForeign &&
          _react2.default.createElement('i', {
              onClick: this.toggleHighlight,
              'data-title': this.props.translate('highlight' + (0, _capitalizeFirstLetter2.default)(promotionStatus) + 'Title'),
              className: (0, _classnames2.default)(
              'icon', 'icon-promoted' +
              (0, _getIconStatus.addEnding)(promotionStatus),
              promotionStatus === 'disabled' && styles.iconTitle) },


            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),


          !isForeign &&
          _react2.default.createElement('i', {
              onClick: this.toggleAutoJumpActivity,
              'data-title': this.props.translate('autoJump' + (0, _capitalizeFirstLetter2.default)(autoJumpStatus) + 'Title'),
              className: (0, _classnames2.default)('icon', styles.iconTitle, 'icon-auto-jump' + (0, _getIconStatus.addEnding)(autoJumpStatus)) },

            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),


          autoJumpEnabled || isForeign ? null :
          _react2.default.createElement('i', {
              onClick: this.toggleMoveToTop,
              'data-title': this.props.translate(moveToTop ? 'jumpToTopTitle' : 'jumpToTopDisableTitle'),
              className: (0, _classnames2.default)(
              'icon',
              styles.iconTitle, 'icon-jump-to-top' + (
              this.checkIfJumpToTopDisabled() ? '-disabled' : '')) },


            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' })),


          !isForeign &&
          _react2.default.createElement('i', {
            onClick: this.toggleRocketPromoted,
            'data-title': this.props.translate('rocketPromotedTitle'),
            className: (0, _classnames2.default)(
            styles.iconTitle, 'icon icon-rocket' + (
            isRocketPromoted ? '-active' : '')) }),




          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.actionCell, (_cx2 = {}, _cx2[styles.tooltipIsOpen] = this.state.isTooltipShown, _cx2)) },
            _react2.default.createElement('span', {
                className: styles.tooltipHandler,
                onClick: this.openControlsModal },

              _react2.default.createElement('i', { className: 'icon icon-more_actions' })))),



        _react2.default.createElement(_components.ShareBlock, {
          locale: this.props.locale,
          translate: this.props.translate,
          sharingData: this.formatShareData(),
          copyLinkTitle: '' + translate('copyLink'),
          emailTitle: '' + translate('propertyDetails', 'contacts', 'email'),
          className: 'shareAgentBlock',
          sizeIcon: 24,
          iconFill: true }),

        this.renderControlsModal()));


  };return OMAgentManageCell;}(_react.Component);exports.default = OMAgentManageCell;


OMAgentManageCell.propTypes = {
  property: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isRtl: _propTypes2.default.bool,
  editProperty: _propTypes2.default.func.isRequired,
  openDetailsPopup: _propTypes2.default.func.isRequired,
  updatePropertyActivity: _propTypes2.default.func.isRequired,
  updatePropertyHighlighting: _propTypes2.default.func.isRequired,
  openContactUsModal: _propTypes2.default.func.isRequired,
  promotedTitle: _propTypes2.default.string,
  propertiesAnalytics: _propTypes2.default.array,
  movePropertyToTop: _propTypes2.default.func,
  openChartOfViews: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  updateAutoJumpToTopActivity: _propTypes2.default.func,
  updateTopPromotionActivity: _propTypes2.default.func,
  loadSinglePropertyAnalytics: _propTypes2.default.func,
  handleCheck: _propTypes2.default.func,
  jumpPromotion: _propTypes2.default.object,
  promotion: _propTypes2.default.object,
  top_promotion: _propTypes2.default.object,
  isSelected: _propTypes2.default.bool.isRequired,
  numberInOrder: _propTypes2.default.number.isRequired,
  disabledPromotionAction: _propTypes2.default.bool,
  isPublishPermissionsForeign: _propTypes2.default.bool,
  toggleRocketPromoted: _propTypes2.default.func };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMAgentManageCell/OMAgentManageCell.js
// module id = 2717
// module chunks = 0